import { createShapeNormalizer } from '@change-corgi/fcm/normalizers';

import { defineFcm } from '../shared/factory';

const STEPS_ASK_COPY_SHAPE = {
	type: 'object',
	shape: {
		stepper: { type: 'string' },
		step_complete_label: { type: 'string' },
		heading: { type: 'string' },
		subheading: { type: 'string' },
		intro: { type: 'string' },
		stat_paragraph: { type: 'string' },
		price_paragraph: { type: 'string' },
	},
} as const;

const STEPS_ASK_COPY_DEFAULT = {
	stepper: '<strong>You signed!</strong> A step closer to victory',
	step_complete_label: 'Your signature is recorded',
	heading: 'This petition is a step closer to victory',
	subheading: 'Keep it free for the next person',
	intro: 'Your voice is heard. Want to further your impact?',
	stat_paragraph: 'Over 70,000 petitions are started on Change.org every month, and more than 700 reach victory.',
	price_paragraph:
		'Chipping in a little each month keeps Change.org running, so anyone can start or sign a petition for a cause they care about. Cancel anytime.',
};

export const FCM_REVENUE_MEMBERSHIP_ASK_DEMONETIZED_EXPERIMENT = defineFcm(
	'revenue_membership_ask_demonetized_experiment',
)
	.asJson(
		createShapeNormalizer({
			type: 'object',
			shape: {
				enabled: { type: 'boolean', optional: true },
				experimentName: { type: 'string', optional: true },
				corgi: {
					type: 'object',
					shape: {
						membership: {
							type: 'object',
							shape: {
								steps_ask: STEPS_ASK_COPY_SHAPE,
							},
						},
					},
				},
			},
		}),
	)
	.withDefault({
		enabled: false,
		experimentName: undefined,
		corgi: {
			membership: {
				steps_ask: STEPS_ASK_COPY_DEFAULT,
			},
		},
	})
	.toConfig({
		owner: 'squad-koi',
		scope: 'corgi-front-end',
		context: 'Demonetized Combo page',
		description:
			'Controls the CHANGE-96409 demonetized Combo page membership-ask experiment (institutional-pitch control vs. "Steps" tone variant) on the psf/membershipAsk page, and carries the "Steps" variant\'s locale- and country-aware copy. ' +
			'See docs/packages/experiments/i18n-copy.md for how to add per-locale/per-country overrides via the FCM Admin UI.',
		supportedGroups: { global: true, locales: true, countries: true },
		import: false,
		template: {
			enabled: true,
			experimentName: '',
			corgi: {
				membership: {
					steps_ask: STEPS_ASK_COPY_DEFAULT,
				},
			},
		},
	});
